<template>
  <v-card text>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex md6>
            <v-text-field
              :value="name"
              :rules="rules"
              disabled
              label="Your Name"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              :value="email"
              disabled
              :rules="rules"
              label="Your Email"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="phone"
              :rules="rules"
              :disabled="!!existingCampaign"
              label="Your Phone Number"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-select
              :items="roles"
              :rules="rules"
              v-model="role"
              label="Roles"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        @click.native="previous"
      >
        Previous
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!valid"
        @click.native="next"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import roles from '../../../../static/account-roles'
  import { mapActions } from 'vuex'
  import lodash from 'lodash'

  export default {
    name: 'StepperContentTwo',
    data () {
      return {
        valid: true,
        phone: '',
        role: 'Digital Director/Consultant',
        roles: [],
        rules: [v => !!v || 'Field is required'],
        reviewFileUrl: null,
        file: null
      }
    },
    props: {
      agency: {
        type: String,
        default: null
      },
      advertiser: {
        type: String,
        default: null
      },
      existingCampaign: {
        type: Object,
        default: () => {}
      }
    },
    created () {
      this.roles = roles
    },
    mounted () {
      if (this.existingCampaign) {
        this.phone = this.existingCampaign.phone
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.getCurrentUser
      },
      name () {
        return this.$store.getters.getCurrentUser.name
      },
      email () {
        return this.$store.getters.getCurrentUser.email
      },
      advertisers () {
        return this.$store.getters.getAdvertisers
      }
    },
    methods: {
      updateAdvertiserPhone () {
        if (!this.existingCampaign) {
          const advertiser = lodash.cloneDeep(this.advertisers.find(a => a.id === this.advertiser))
          advertiser.data.phone = this.phone
          this.$store.dispatch('updateAdvertiser', advertiser)
        }
      },
      next () {
        if (this.$refs.form.validate()) {
          this.updateAdvertiserPhone()
          const user = Object.assign({}, this.currentUser.firebaseAccount)
          if (this.agency) {
            user.selectedOrganization = this.agency
            user.organizations = [{
              id: this.agency,
              role: 'admin'
            }]
          }
          user.selectedAdvertiser = this.advertiser
          if (user.advertisers && user.advertisers.length) {
            user.advertisers = [...user.advertisers, {
              id: this.advertiser,
              title: this.role,
              fb_ad_account_permissions: ["ANALYZE", "ADVERTISE"]
            }]
          } else {
            user.advertisers = [{
              id: this.advertiser,
              title: this.role,
              fb_ad_account_permissions: ["ANALYZE", "ADVERTISE"]
            }]
          }
          this.$store.dispatch('updateUser', user)
          this.$emit('setPage', 3)
        }
      },
      createReviewURL () {
        const file = this.$refs.file.files[0]
        if (!file) return false
        const allowFileTypes = ['image/gif', 'image/png', 'image/jpg', 'image/jpeg']
        if (!allowFileTypes.find(type => type === file.type)) {
          this.showNotification({
            type: 'warning',
            message: ['Next file types allowed: gif, png, jpg, jpeg']
          })
          return false
        }
        this.reviewFileUrl = URL.createObjectURL(file)
        this.file = file
      },
      previous () {
        this.$emit('setPage', 1)
      },
      ...mapActions([
        'showNotification'
      ])
    }
  }
</script>
